export enum EnumTypePerson {
  Natural = '0',
  Legal = '1'
}
